import { AuthorizationServiceConfiguration } from '../authorization_service_configuration';
import { AppAuthError } from '../errors';
import { BasicQueryStringUtils, QueryStringUtils } from '../query_string_utils';
import { JQueryRequestor, Requestor } from '../xhr';
import { IntrospectionRequest } from './introspection_request';
import { IntrospectionError, IntrospectionErrorJson, IntrospectionResponse, IntrospectionResponseJson } from './introspection_response';

/**
 * Represents an interface which can make a introspection request.
 */
export interface IntrospectionRequestHandler {
  /**
   * Performs the introspection request, given the service configuration.
   */
  performIntrospectionRequest(
    configuration: AuthorizationServiceConfiguration,
    request: IntrospectionRequest,
    accessToken: string
  ): Promise<IntrospectionResponse>;
}

/**
 * The default introspection request handler.
 */
export class BaseIntrospectionRequestHandler implements IntrospectionRequestHandler {

  constructor(
    public readonly requestor: Requestor = new JQueryRequestor(),
    public readonly utils: QueryStringUtils = new BasicQueryStringUtils()) { }

  private isIntrospectionResponse(response: IntrospectionResponseJson |
    IntrospectionErrorJson): response is IntrospectionResponseJson {
    return (response as IntrospectionErrorJson).error === undefined;
  }

  performIntrospectionRequest(
    configuration: AuthorizationServiceConfiguration,
    request: IntrospectionRequest,
    accessToken: string
  ): Promise<IntrospectionResponse> {
    const introspectionResponse =
      this.requestor.xhr<IntrospectionResponseJson | IntrospectionErrorJson>({
        url: configuration.introspectionEndpoint,
        method: 'POST',
        dataType: 'json',  // adding implicit dataType
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          Authorization: 'Bearer ' + accessToken
        },
        data: this.utils.stringify(request.toStringMap()),
      });

    return introspectionResponse.then(response => {
      if (this.isIntrospectionResponse(response)) {
        return new IntrospectionResponse(response);
      } else {
        return Promise.reject<IntrospectionResponse>(
          new AppAuthError(response.error, new IntrospectionError(response)));
      }
    });
  }
}
